<template>
  <div>
    <main class="single-news">
      <main-header fixed />

      <sui-loader v-show="fetching" size="large" class="general-loader" active centered inline />
      <div v-show="!fetching">
        <div class="single-news__header">
          <sui-grid :columns="2">
            <sui-grid-row centered>
              <sui-grid-column :computer="10" :mobile="16">
                <h2>{{ title }}</h2>
              </sui-grid-column>

              <sui-grid-column :computer="10" :mobile="16" class="single-news__infos-mobile">
                {{ date }} <br />
                {{ country }}
              </sui-grid-column>

              <sui-grid-column :computer="6" :mobile="16">
                <p>
                  {{ shortContent }}
                </p>
              </sui-grid-column>
            </sui-grid-row>
          </sui-grid>
        </div>

        <full-image
          :class="['single-news__featured', { 'single-news__featured--slider': true }]"
          v-if="images"
          :images="images"
        />

        <div class="single-news__content">
          <sui-grid :columns="2">
            <sui-grid-row centered>
              <sui-grid-column :computer="5" :mobile="16" class="single-news__content__infos">
                {{ date }} <br />
                {{ country }}
              </sui-grid-column>

              <sui-grid-column :computer="11" :mobile="16" class="single-news__content__paragraphs">
                <p class="single-news__content__paragraphs__content" v-html="content"></p>
              </sui-grid-column>
            </sui-grid-row>
          </sui-grid>
        </div>

        <div class="single-news__related">
          <frame-related-news
            :items="newsRelated"
            :buttonText="$t('generals.readmore')"
            :title="$t('generals.related-news')"
            :fetching="fetching"
          />
        </div>
      </div>
      <scroll-to />
    </main>
    <main-footer ref="footer" style="bottom: 0;" />
  </div>
</template>

<script>
import FullImage from "../components/frames/full-image";
import RelatedNews from "@/components/news/related-news";
import StaffImage from "@/assets/staff.png";

export default {
  name: "SingleNews",
  components: {
    FullImage,
    "frame-related-news": RelatedNews,
  },

  data() {
    return {
      image: {
        url: StaffImage,
      },
      images: [],
      newsRelated: [],
      date: "",
      country: "",
      title: "",
      content: "",
      shortContent: "",
      fetching: true,
    };
  },

  destroyed() {
    $("body, html").removeAttr("style");
    this.$hub.$off("repeatRequests");
  },

  mounted() {
    const { lang, slug } = this.$route.params;
    this.getData(lang === "pt" ? "pt-br" : lang, slug);

    this.$hub.$on("repeatRequests", (language) => {
      this.getData(language, slug);
    });
  },

  methods: {
    getData(language, slug) {
      this.fetching = true;

      this.$news
        .getSingle(language, slug)
        .then((resolve) => {
          const {
            relatedNews,
            featured,
            title,
            date,
            // eslint-disable-next-line camelcase
            regional_name,
            content,
            // eslint-disable-next-line camelcase
            short_content,
          } = resolve.data.items;

          this.newsRelated = relatedNews;
          this.images = featured;
          this.title = title;
          this.date = date.split("/").join(".");
          // eslint-disable-next-line camelcase
          this.country = regional_name;
          this.content = content;
          // eslint-disable-next-line camelcase
          this.shortContent = short_content;
          document.dispatchEvent(new Event("prerender-ready"));
        })
        .catch(() => {
          document.dispatchEvent(new Event("prerender-ready"));
        })
        .finally(() => {
          this.fetching = false;
        });
    },
  },
};
</script>

<style lang="scss">
.single-news {
  background: white;
  height: 100%;
  min-height: 100vh;
  overflow: hidden;
  position: relative;
  color: black;
  z-index: 2;
  padding: 60px 0 0;
  position: relative;
  margin-bottom: 300px;

  &__header {
    width: 100%;
    padding: 0 10%;
    margin: 150px auto 50px;

    .row {
      .column {
        display: flex !important;
        align-items: flex-end !important;
      }
    }

    h2 {
      font-family: $david;
      font-weight: 300;
      max-width: 530px;
      font-size: 90px;
      line-height: 70px;
    }

    &__content {
      font-family: $hwcigars;
      font-weight: 300;
      font-size: 22px;
      letter-spacing: 1px;
      margin: 0 auto;
    }

    p {
      font-family: $hwcigars;
      font-weight: 300;
      font-size: 22px;
      margin: 0 auto;
      padding-bottom: 15px;
    }
  }

  &__featured {
    max-width: 1500px;
    margin: 0 auto;
    padding: 30px 0 50px;

    &--slider {
      max-width: none;
    }

    .frame-full-image__default {
      margin: 0 auto;
      max-width: 83.5vw !important;
    }
  }

  &__infos-mobile {
    font-family: $tertiary;
    letter-spacing: 0px !important;

    &.column {
      &.computer {
        display: none !important;
      }
    }
  }

  &__content {
    padding: 0 40px;
    margin: 0 auto;
    max-width: 83vw;

    &__infos {
      font-family: $tertiary;
      font-size: 44px;
      letter-spacing: 0px;
      font-weight: 300;
      line-height: 1.3em;
      display: flex !important;
      position: relative;
      padding-left: 10px !important;
    }

    &__paragraphs {
      font-size: 22px;
      font-weight: 300;

      &__content {
        max-width: 750px;
      }

      blockquote {
        font-family: $saolitalic;
        font-weight: 300;
        font-style: normal;
        font-size: 55px;
        margin: 50px 0;
        display: block;
        position: relative;
        line-height: 1.2em;

        p {
          &::before {
            content: open-quote;
            position: absolute;
            left: -20px;
            top: 0;
          }

          &::after {
            content: close-quote;
            position: absolute;
            bottom: 0;
          }
        }
      }
    }
  }

  &__related {
    margin-top: 120px;
  }
}

@media (max-width: 1500px) {
  .single-news {
    &__content {
      &__infos {
        left: 0;
        padding-left: 0 !important;
      }
    }
  }
}

@media (max-width: 1000px) {
  .single-news {
    &__featured {
      .frame-full-image__default {
        margin: 0 auto;
        max-width: 100% !important;
      }
    }

    &__header {
      padding: 0 20px;
      margin-top: 40px;

      h2 {
        max-width: 240px;
        letter-spacing: 1px;
        line-height: 50px;
        font-size: 50px;
      }

      p {
        display: block;
        width: 100%;
        font-size: 17px;
      }
    }

    &__infos-mobile {
      font-size: 17px !important;

      &.column {
        &.computer {
          margin: 30px 0 !important;
          display: block !important;
        }
      }

      display: block;
      font-size: 20px;
      letter-spacing: 1px;
      font-weight: 300;
      line-height: 1.3em;
      width: 100%;
    }

    &__content {
      max-width: 100%;

      &__infos {
        display: none !important;
      }

      &__paragraphs {
        padding: 0 !important;

        p {
          width: 100%;
          max-width: none;
          font-size: 17px;
        }

        blockquote {
          font-size: 30px;
          font-size: 30px;
          max-width: 80%;
          margin: 40px auto 20px;

          p {
            &::before {
              content: open-quote;
              position: absolute;
              left: -15px;
              top: 0;
            }

            &::after {
              content: close-quote;
              position: absolute;
            }
          }
        }
      }
    }
  }
}
</style>
